import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2bb3d779&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2bb3d779&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb3d779",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bb3d779')) {
      api.createRecord('2bb3d779', component.options)
    } else {
      api.reload('2bb3d779', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2bb3d779&scoped=true", function () {
      api.rerender('2bb3d779', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/storeCoupon/index.vue"
export default component.exports